
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registracia",
      function () {
        return require("private-next-pages/registracia.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/registracia"])
      });
    }
  